// src/components/home/PlannedAppointmentsSection.js
import React from 'react';
import './PlannedAppointmentsSection.css';

const PlannedAppointmentsSection = () => {
  return (
    <section className="planned-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Finally Solve Your Planned Appointments Problem</h2>
          <p className="section-subtitle">
            You plan a crown. The patient leaves without scheduling. You never see them again. Sound familiar?
          </p>
        </div>

        {/* Problem Statement */}
        <div className="problem-statement">
          <div className="problem-icon">😰</div>
          <div className="problem-text">
            <strong>Every dental practice struggles with this:</strong> Dentist plans treatment, patient says "I'll call to schedule," then... nothing. Thousands of dollars in planned treatment just sitting in Open Dental, never completed.
          </div>
        </div>

        {/* Solution Flow */}
        <div className="solution-flow">
          <div className="flow-title">Here's How BookDentist.pro Solves This:</div>
          
          <div className="flow-steps">
            <div className="flow-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <div className="step-title">Dentist Plans Treatment</div>
                <div className="step-description">
                  Dr. Smith examines Sarah and plans a crown. It's entered into Open Dental as a planned appointment—just like you already do.
                </div>
              </div>
            </div>

            <div className="flow-arrow">→</div>

            <div className="flow-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <div className="step-title">Patient Gets Email/SMS</div>
                <div className="step-description">
                  Sarah gets a text: "Hi Sarah! Dr. Smith planned your Crown Preparation. Click here to schedule your appointment."
                </div>
              </div>
            </div>

            <div className="flow-arrow">→</div>

            <div className="flow-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <div className="step-title">Books in 30 Seconds</div>
                <div className="step-description">
                  Sarah clicks the link on her phone, sees available times for her crown prep, picks Tuesday at 2:00 PM, done. No phone call needed.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Results Grid */}
        <div className="results-grid">
          <div className="result-box">
            <div className="result-stat">40%</div>
            <div className="result-label">More Planned Appointments Actually Completed</div>
            <div className="result-description">
              When patients can book instantly from their phone, they actually do it.
            </div>
          </div>

          <div className="result-box">
            <div className="result-stat">$0</div>
            <div className="result-label">Phone Calls from Your Front Desk</div>
            <div className="result-description">
              No more calling patients 3 times trying to schedule their planned work.
            </div>
          </div>

          <div className="result-box">
            <div className="result-stat">24/7</div>
            <div className="result-label">Patients Book When It's Convenient</div>
            <div className="result-description">
              Most bookings happen after 6 PM—when your office is closed.
            </div>
          </div>
        </div>

        {/* Testimonial */}
        <div className="testimonial-box">
          <div className="testimonial-quote">"</div>
          <div className="testimonial-text">
            We were losing thousands in planned treatment because patients would leave saying 'I'll call to schedule' and never did. Now they get a text, book it themselves in 30 seconds, and our planned appointment completion rate went from 45% to 87%. It's literally printing money.
          </div>
          <div className="testimonial-author">
            <strong>Dr. Jennifer Martinez</strong><br />
            Martinez Family Dentistry, Austin, TX
          </div>
        </div>

        {/* Technical Details */}
        <div className="technical-details">
          <div className="tech-detail-title">How It Works Technically:</div>
          <div className="tech-details-grid">
            <div className="tech-detail-item">
              <div className="tech-detail-icon">🔍</div>
              <div className="tech-detail-text">
                <strong>Detects Planned Appointments:</strong> BookDentist.pro automatically detects planned appointments in your Open Dental database
              </div>
            </div>
            <div className="tech-detail-item">
              <div className="tech-detail-icon">📧</div>
              <div className="tech-detail-text">
                <strong>Sends Smart Reminders:</strong> Patient gets email/SMS with procedure name, estimated time, and a "Book Now" button
              </div>
            </div>
            <div className="tech-detail-item">
              <div className="tech-detail-icon">📅</div>
              <div className="tech-detail-text">
                <strong>Shows Available Slots:</strong> Patient sees real available times that work for the procedure length and provider
              </div>
            </div>
            <div className="tech-detail-item">
              <div className="tech-detail-icon">✅</div>
              <div className="tech-detail-text">
                <strong>Books Instantly:</strong> Patient picks a time, appointment is created in Open Dental, planned appointment is completed
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlannedAppointmentsSection;